import { render, staticRenderFns } from "./StkScLDefault.vue?vue&type=template&id=4862595f"
import script from "./StkScLDefault.vue?vue&type=script&lang=js"
export * from "./StkScLDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports